export const UNABLE_TO_RESET_PASSWORD = 'Unable to reset password';
export const LOCKDOWN_TOOLTIP = 'Lock drivers route sequence on Saturn';
export const LEAVE_FROM_SATELLITE_DEPOT_TOOLTIP =
  'Drivers Route departs from a satellite depot';
export const RETURN_TO_SATELLITE_DEPOT_TOOLTIP =
  'Drivers route returns to a satellite depot';
export const PROCEED_WITH_PASSWORD_CHANGES = 'Proceed with password change?';
export const YOU_HAVE_UNSAVED_CHANGES = 'You have unsaved changes';
export const ARE_YOU_WANT_TO_DISCARD = 'Are you sure you want to discard them?';
export const NEW_DRIVER_CREATED =
  'Driver was created successfully and assigned to the route';
export const ERROR_$ = (message) => `Error - ${message}`;
export const SOMETHING_WENT_WRONG = ERROR_$('Something went wrong');
export const PLEASE_FIX_ERRORS = 'Please review & fix all errors';
export const VEHICLE_IS_LGV =
  'LGV Vehicle Type selected. Please ensure all vehicle detail are correct as optimisation will be affected.';
